import { RequestsQueue } from './RequestsQueue'

/** An app's 요청 tab: the same queue, fixed to the app. */
export default function AppRequests({ appId }: { appId: number }) {
  return <RequestsQueue appId={appId} />
}
